import { Component, computed } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MenuService } from 'src/app/services/menu.service';
import { SelectionStateService } from 'src/app/services/selection-state.service';
import { AccountActionsService } from 'src/app/services/account-actions.service';
import { UtilsService } from 'src/app/services/utils.service';
import { AccountRow, accountSheetRows, initialsOf, roleShortcuts, sellersShortcuts } from 'src/app/utils/account-menu';
import { AUTO_HEIGHT_SHEET_CLASS, autoHeightSheetOptions } from 'src/app/utils/auto-height-sheet';

/** Sheet de cuenta del avatar del header. Reemplaza al menú lateral y al modal de cambio de rol. */
/** Clase del ion-modal del sheet de cuenta: esquinas superiores redondeadas (global.scss). */
const ACCOUNT_SHEET_CLASS = 'account-sheet-modal';

@Component({
  selector: 'app-account-sheet',
  templateUrl: './account-sheet.component.html',
  styleUrls: ['./account-sheet.component.scss'],
  standalone: false,
})
export class AccountSheetComponent {
  readonly fullname = computed(() => this.menuService.userSignal()?.fullname ?? '');
  readonly initials = computed(() => initialsOf(this.fullname()));
  readonly role = this.selectionState.selectedRole;
  readonly roleKey = computed(() => 'login.roles.' + this.role());
  readonly shortcuts = computed(() => this.selectionState.isSellersUser()
    ? sellersShortcuts(this.selectionState.isBusinessAdmin() || this.selectionState.isBoss())
    : roleShortcuts(this.selectionState.selectedRole()));
  readonly accountRows = computed(() => accountSheetRows());
  readonly version = this.utils.appVersion.version;

  constructor(
    private readonly menuService: MenuService,
    private readonly selectionState: SelectionStateService,
    private readonly actions: AccountActionsService,
    private readonly utils: UtilsService,
    private readonly modalCtrl: ModalController,
  ) {}

  async onRowSelected(row: AccountRow): Promise<void> {
    // Se cierra primero: el logout abre un alert y la navegación no debe quedar debajo del sheet.
    await this.modalCtrl.dismiss();
    await this.actions.run(row);
  }

  static async open(modalCtrl: ModalController): Promise<void> {
    const modal = await modalCtrl.create({
      component: AccountSheetComponent,
      ...autoHeightSheetOptions(),
      cssClass: [AUTO_HEIGHT_SHEET_CLASS, ACCOUNT_SHEET_CLASS],
      // El componente dibuja su propio .sheet-grab (como el mockup): sin el handle de Ionic, que se superponía.
      handle: false,
      canDismiss: true,
    });
    await modal.present();
  }
}
